import {ColDef, ColGroupDef} from '../types/AgGridTypes';

export function isColDef(def: ColDef | ColGroupDef): def is ColDef {
  return !('children' in def);
}
